"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getEmailReplacements = exports.getStageReplacements = exports.getEventReplacements = exports.buildInterviewPanelString = exports.replaceLabels = exports.replaceValues = exports.STAGE_PLACEHOLDERS = exports.EMAIL_PLACEHOLDERS = exports.EVENT_PLACEHOLDERS = void 0;
var html_ast_transform_1 = require("html-ast-transform");
var html_entities_1 = require("html-entities");
var isomorphic_dompurify_1 = __importDefault(require("isomorphic-dompurify"));
var lodash_1 = __importDefault(require("lodash"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var event_date_groups_1 = require("./event-date-groups");
var strings_1 = require("./strings");
// Override some Moment Timezone Abbreviations
//
var zone = moment_timezone_1["default"].tz.zone("Asia/Dubai");
if (zone) {
    zone.abbrs[0] = "GST";
}
var GUIDE_PLACEHOLDERS = [
    { id: "candidate-first-name", label: "Candidate First Name" },
    { id: "candidate-full-name", label: "Candidate Full Name" },
    { id: "company-name", label: "Company" },
    { id: "job-role-name", label: "Job Role" },
    { id: "recruiter-first-name", label: "Recruiter First Name" },
    { id: "recruiter-full-name", label: "Recruiter Full Name" },
    { id: "coordinator-first-name", label: "Coordinator First Name" },
    { id: "coordinator-full-name", label: "Coordinator Full Name" },
    { id: "greenhouse-job-link", label: "Greenhouse Job Link" },
];
exports.EVENT_PLACEHOLDERS = lodash_1["default"].unionBy(GUIDE_PLACEHOLDERS, [
    { id: "all-interviewers-full-names", label: "All Interviewer Full Names" },
    {
        id: "all-interviewers-first-names",
        label: "All Interviewer First Names"
    },
    {
        id: "first-interviewer-first-name",
        label: "First Interviewer First Name"
    },
    { id: "first-interviewer-full-name", label: "First Interviewer Full Name" },
    { id: "first-interviewer-title", label: "First Interviewer Job Title" },
], "id");
exports.EMAIL_PLACEHOLDERS = lodash_1["default"].unionBy(exports.EVENT_PLACEHOLDERS, [
    { id: "next-interview-date", label: "Next Interview Date" },
    { id: "next-interview-time", label: "Next Interview Time" },
    { id: "upcoming-interview-date", label: "Upcoming Interview Date" },
    { id: "upcoming-interview-time", label: "Upcoming Interview Time" },
    {
        id: "remaining-interview-datetime-range",
        label: "Remaining Interviews Time Range"
    },
    {
        id: "remaining-interview-panel",
        label: "Interview Panel"
    },
    {
        id: "remaining-interview-panel-with-interviewers",
        label: "Interview Panel with Interviewers"
    },
    {
        id: "remaining-interview-panel-with-interviewers-full-names",
        label: "Interview Panel with Interviewers (Full Names)"
    },
    { id: "guide-link", label: "Interview Guide Link" },
    { id: "scheduler-link", label: "Interview Scheduler Link" },
    { id: "sender-name", label: "Sender Name" },
], "id");
exports.STAGE_PLACEHOLDERS = GUIDE_PLACEHOLDERS;
var replaceValues = function (value, replacements, options) {
    return (0, html_entities_1.decode)((0, html_ast_transform_1.transform)(value, {
        replaceTags: {
            span: function (node) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var tag = (0, html_ast_transform_1.getAttr)(node, "data-id");
                if (tag) {
                    var tagValue = replacements[tag];
                    if (tagValue) {
                        return (0, html_ast_transform_1.h)("#text", tagValue);
                    }
                    if (options === null || options === void 0 ? void 0 : options.throwOnMissing) {
                        throw new Error("Missing tag " + tag);
                    }
                    else {
                        return (0, html_ast_transform_1.h)("#text", "");
                    }
                }
                return node;
            }
        },
        trimWhitespace: false
    }));
};
exports.replaceValues = replaceValues;
var replaceLabels = function (value, replacements, throwOnMissing) {
    if (throwOnMissing === void 0) { throwOnMissing = false; }
    return (0, html_ast_transform_1.transform)(value, {
        replaceTags: {
            span: function (node) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var tag = (0, html_ast_transform_1.getAttr)(node, "data-id");
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var tagLabel = (0, html_ast_transform_1.getAttr)(node, "data-label");
                if (tag) {
                    var tagValue = replacements[tag];
                    if (tagValue) {
                        var tagValueNode = (0, html_ast_transform_1.h)(tagValue);
                        var childNodes = [];
                        var label = tagValue;
                        // Support the case where we replacing the label with HTML content, like a link
                        if ("tagName" in tagValueNode &&
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            tagValueNode.tagName) {
                            var firstTextNode = lodash_1["default"].find(
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            tagValueNode.childNodes, {
                                nodeName: "#text"
                            });
                            label = (firstTextNode === null || firstTextNode === void 0 ? void 0 : firstTextNode.value) || tagValue;
                            childNodes.push(firstTextNode);
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            var n_1 = (0, html_ast_transform_1.withAttr)(node, "data-label", label);
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            n_1.childNodes = childNodes;
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            var variable_1 = (0, html_ast_transform_1.withClass)(tagValueNode, "guide-VariableToken variant-read");
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            variable_1.childNodes = [n_1];
                            return variable_1;
                        }
                        var child = (0, html_ast_transform_1.h)("#text", tagValue);
                        childNodes.push(child);
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        var n = (0, html_ast_transform_1.withAttr)(node, "data-label", label);
                        var variable_2 = (0, html_ast_transform_1.withClass)(n, "guide-VariableToken variant-read");
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        variable_2.childNodes = childNodes;
                        return variable_2;
                    }
                    if (throwOnMissing) {
                        throw new Error("Missing tag " + tag);
                    }
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    if (!node.childNodes.length && tagLabel) {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        node.childNodes.push((0, html_ast_transform_1.h)("#text", tagLabel));
                    }
                }
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var variable = (0, html_ast_transform_1.withClass)(node, "guide-VariableToken variant-read is-undefined");
                return variable;
            }
        },
        trimWhitespace: false
    });
};
exports.replaceLabels = replaceLabels;
var buildInterviewPanelString = function (_a) {
    var sortedVisibleEvents = _a.sortedVisibleEvents, timezone = _a.timezone, _b = _a.useTimeRanges, useTimeRanges = _b === void 0 ? true : _b, _c = _a.withInterviewers, withInterviewers = _c === void 0 ? false : _c, _d = _a.withInterviewerFullNames, withInterviewerFullNames = _d === void 0 ? false : _d, _e = _a.html, html = _e === void 0 ? true : _e;
    var dateGroups = (0, event_date_groups_1.getEventDateGroups)(sortedVisibleEvents);
    var LINE_OPEN = html ? "<span>" : "";
    var LINE_CLOSE = html ? "</span>" : "";
    var LINE_BREAK = html ? "<br>" : "\n";
    var MIDDOT = html ? "  &middot;" : "•";
    var SPACE = html ? "&nbsp;" : " ";
    var res = "";
    if (dateGroups.length) {
        var includeDayHeaders_1 = dateGroups.length > 1;
        res = dateGroups.reduce(function (acc, next, idx) {
            var dateGroupStartTime = next.startTime, dateGroupEvents = next.events;
            var dayEventsStr = "";
            dateGroupEvents.forEach(function (eventOrBreak, eventIdx) {
                if ("lengthMinutes" in eventOrBreak) {
                    var breakTime = moment_timezone_1["default"]
                        .duration(eventOrBreak.lengthMinutes, "minutes")
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        .format("h [hr] m [min]", {
                        usePlural: false,
                        trim: "all"
                    });
                    var lineBreak_1 = eventIdx === dateGroupEvents.length - 1 ? "" : LINE_BREAK;
                    dayEventsStr = "" + dayEventsStr + LINE_OPEN + SPACE.repeat(6) + "~ " + breakTime + " break ~" + LINE_CLOSE + lineBreak_1;
                    return;
                }
                var event = eventOrBreak;
                var sanitizedTitle = isomorphic_dompurify_1["default"].sanitize(event.title, {
                    ALLOWED_TAGS: []
                });
                var interviewersStr = "";
                if (withInterviewers && event.interviewers.length) {
                    interviewersStr = " with " + (0, lodash_1["default"])(event.interviewers)
                        .map(function (_a) {
                        var firstName = _a.firstName, lastName = _a.lastName;
                        if (withInterviewerFullNames) {
                            return (0, strings_1.joinNames)(firstName, lastName);
                        }
                        return firstName;
                    })
                        .sort()
                        .thru(strings_1.joinWithFinalSeparator)
                        .value();
                }
                var interviewTime;
                if (useTimeRanges) {
                    interviewTime = moment_timezone_1["default"]
                        .tz(event.startTime, timezone)
                        .format("h:mm") + " - " + moment_timezone_1["default"]
                        .tz(event.endTime, timezone)
                        .format("h:mm a z") + ": ";
                }
                else {
                    interviewTime = moment_timezone_1["default"]
                        .tz(event.startTime, timezone)
                        .format("h:mm a z") + " - ";
                }
                var lineBreak = eventIdx === dateGroupEvents.length - 1 ? "" : LINE_BREAK;
                dayEventsStr = "" + dayEventsStr + LINE_OPEN + MIDDOT + interviewTime + sanitizedTitle + interviewersStr + LINE_CLOSE + lineBreak;
            });
            var dayHeader = moment_timezone_1["default"]
                .tz(dateGroupStartTime, timezone)
                .format("ddd MMM Do");
            var lineBreak = idx === dateGroups.length - 1 ? "" : "" + LINE_BREAK + LINE_BREAK;
            var dayStr = "" + (includeDayHeaders_1
                ? "" + LINE_OPEN + dayHeader + LINE_CLOSE + LINE_BREAK
                : "") + dayEventsStr + lineBreak;
            return "" + acc + dayStr;
        }, "");
    }
    return res;
};
exports.buildInterviewPanelString = buildInterviewPanelString;
var getEventReplacements = function (data) {
    var _a, _b;
    var interviewers = data.interviewers, candidateFirstName = data.candidateFirstName, candidateFullName = data.candidateFullName, recruiterFirstName = data.recruiterFirstName, recruiterFullName = data.recruiterFullName, coordinatorFirstName = data.coordinatorFirstName, coordinatorFullName = data.coordinatorFullName, companyName = data.companyName, jobRoleName = data.jobRoleName, greenhouseJobUrl = data.greenhouseJobUrl;
    var greenhouseJobLink = greenhouseJobUrl &&
        "<a href=\"" + greenhouseJobUrl + "\" target=\"_blank\" rel=\"noopener noreferrer\">Job Description</a>";
    var allInterviewersFirstNames = (0, lodash_1["default"])(interviewers)
        .map("firstName")
        .sort()
        .thru(strings_1.joinWithFinalSeparator)
        .value();
    var allInterviewersFullNames = (0, lodash_1["default"])(interviewers)
        .map(function (_a) {
        var firstName = _a.firstName, lastName = _a.lastName;
        return (0, strings_1.joinNames)(firstName, lastName);
    })
        .sort()
        .thru(strings_1.joinWithFinalSeparator)
        .value();
    var firstInterviewer = (0, lodash_1["default"])(interviewers).sortBy("name").first();
    return {
        "company-name": companyName !== null && companyName !== void 0 ? companyName : "",
        "job-role-name": jobRoleName !== null && jobRoleName !== void 0 ? jobRoleName : "",
        "all-interviewers-full-names": allInterviewersFullNames !== null && allInterviewersFullNames !== void 0 ? allInterviewersFullNames : "",
        "all-interviewers-first-names": allInterviewersFirstNames !== null && allInterviewersFirstNames !== void 0 ? allInterviewersFirstNames : "",
        "candidate-first-name": candidateFirstName !== null && candidateFirstName !== void 0 ? candidateFirstName : "",
        "candidate-full-name": candidateFullName !== null && candidateFullName !== void 0 ? candidateFullName : "",
        "first-interviewer-first-name": (_a = firstInterviewer === null || firstInterviewer === void 0 ? void 0 : firstInterviewer.firstName) !== null && _a !== void 0 ? _a : "",
        "first-interviewer-full-name": (0, strings_1.joinNames)(firstInterviewer === null || firstInterviewer === void 0 ? void 0 : firstInterviewer.firstName, firstInterviewer === null || firstInterviewer === void 0 ? void 0 : firstInterviewer.lastName),
        "first-interviewer-title": (_b = firstInterviewer === null || firstInterviewer === void 0 ? void 0 : firstInterviewer.title) !== null && _b !== void 0 ? _b : "",
        "recruiter-first-name": recruiterFirstName !== null && recruiterFirstName !== void 0 ? recruiterFirstName : "",
        "recruiter-full-name": recruiterFullName !== null && recruiterFullName !== void 0 ? recruiterFullName : "",
        "coordinator-first-name": coordinatorFirstName !== null && coordinatorFirstName !== void 0 ? coordinatorFirstName : "",
        "coordinator-full-name": coordinatorFullName !== null && coordinatorFullName !== void 0 ? coordinatorFullName : "",
        "greenhouse-job-link": greenhouseJobLink !== null && greenhouseJobLink !== void 0 ? greenhouseJobLink : ""
    };
};
exports.getEventReplacements = getEventReplacements;
var getStageReplacements = function (data) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var greenhouseJobLink = data.greenhouseJobUrl &&
        "<a href=\"" + data.greenhouseJobUrl + "\" target=\"_blank\" rel=\"noopener noreferrer\">Job Description</a>";
    return {
        "candidate-first-name": (_a = data.candidateFirstName) !== null && _a !== void 0 ? _a : "",
        "candidate-full-name": (_b = data.candidateFullName) !== null && _b !== void 0 ? _b : "",
        "company-name": (_c = data.companyName) !== null && _c !== void 0 ? _c : "",
        "job-role-name": (_d = data.jobRoleName) !== null && _d !== void 0 ? _d : "",
        "recruiter-first-name": (_e = data.recruiterFirstName) !== null && _e !== void 0 ? _e : "",
        "recruiter-full-name": (_f = data.recruiterFullName) !== null && _f !== void 0 ? _f : "",
        "coordinator-first-name": (_g = data.coordinatorFirstName) !== null && _g !== void 0 ? _g : "",
        "coordinator-full-name": (_h = data.coordinatorFullName) !== null && _h !== void 0 ? _h : "",
        "greenhouse-job-link": greenhouseJobLink !== null && greenhouseJobLink !== void 0 ? greenhouseJobLink : ""
    };
};
exports.getStageReplacements = getStageReplacements;
var getEmailReplacements = function (data) {
    var allInterviewers = data.allInterviewers, guideUrl = data.guideUrl, greenhouseJobUrl = data.greenhouseJobUrl, sortedVisibleUpcomingEvents = data.sortedVisibleUpcomingEvents, timezone = data.timezone;
    var nextInterviewDay = "";
    var nextInterviewTime = "";
    var upcomingInterviewTime = "";
    var upcomingInterviewDate = "";
    var remainingInterviewDatetimeRange = "";
    var remainingInterviewPanel = "";
    var remainingInterviewPanelWithInterviewers = "";
    var remainingInterviewPanelWithInterviewersFullNames = "";
    if ((sortedVisibleUpcomingEvents === null || sortedVisibleUpcomingEvents === void 0 ? void 0 : sortedVisibleUpcomingEvents.length) && timezone) {
        var nextEvent_1 = lodash_1["default"].first(sortedVisibleUpcomingEvents);
        var nextEventStartTime_1 = moment_timezone_1["default"].tz(nextEvent_1.startTime, timezone);
        upcomingInterviewDate = nextEventStartTime_1.format("dddd, MMM Do");
        upcomingInterviewTime = nextEventStartTime_1.format("h:mm a z");
        var lastSameDayEvent = lodash_1["default"].findLast(sortedVisibleUpcomingEvents, function (_a) {
            var startTime = _a.startTime, endTime = _a.endTime;
            return (
            // We need to ensure we at least pick the next event
            startTime === (nextEvent_1 === null || nextEvent_1 === void 0 ? void 0 : nextEvent_1.startTime) ||
                moment_timezone_1["default"].tz(endTime, timezone).isSame(nextEventStartTime_1, "day"));
        });
        // Even if we have sorted visible events, we may not have an event for the same day,
        // based on the current timezone, which defaults to the user's timezone
        if (lastSameDayEvent) {
            var lastSameDayEventEndTime = moment_timezone_1["default"].tz(lastSameDayEvent.endTime, timezone);
            nextInterviewDay = nextEventStartTime_1.format("dddd, MMM Do");
            nextInterviewTime = nextEventStartTime_1.format("h:mm a") + " - " + lastSameDayEventEndTime.format("h:mm a z");
            var lastEvent = lodash_1["default"].last(sortedVisibleUpcomingEvents);
            var lastEventEndTime = moment_timezone_1["default"].tz(lastEvent.endTime, timezone);
            if (nextEventStartTime_1.isSame(lastEventEndTime, "day")) {
                remainingInterviewDatetimeRange = nextEventStartTime_1.format("ddd M/D h:mm a") + " - " + lastEventEndTime.format("h:mm a z");
            }
            else {
                remainingInterviewDatetimeRange = (0, lodash_1["default"])(sortedVisibleUpcomingEvents)
                    .groupBy(function (event) {
                    var localizedStartTime = moment_timezone_1["default"].tz(event.startTime, timezone);
                    var localizedEndTime = moment_timezone_1["default"].tz(event.endTime, timezone);
                    // If an event starts and ends on different days, create a new grouping
                    // with the end time instead of the start time
                    if (!localizedStartTime.isSame(localizedEndTime, "day")) {
                        return moment_timezone_1["default"].tz(event.endTime, timezone).startOf("day");
                    }
                    return moment_timezone_1["default"].tz(event.startTime, timezone).startOf("day");
                })
                    .mapValues(function (groupedEvents) {
                    var firstGroupedEventStartTime = moment_timezone_1["default"].tz(lodash_1["default"].first(groupedEvents).startTime, timezone);
                    var lastGroupedEventEndTime = moment_timezone_1["default"].tz(lodash_1["default"].last(groupedEvents).endTime, timezone);
                    // We need to handle the edge case where the last event crosses the day boundary
                    // and when it does ALSO add the day to the format string for both times.
                    var crossesDayBoundary = !firstGroupedEventStartTime.isSame(lastGroupedEventEndTime, "day");
                    return firstGroupedEventStartTime.format("ddd M/D h:mm a") + " - " + lastGroupedEventEndTime.format(crossesDayBoundary ? "ddd M/D h:mm a z" : "h:mm a z");
                })
                    .values()
                    // Typescript isn't smart enough to use _ as placeholders
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    .thru(lodash_1["default"].partial(strings_1.joinWithFinalSeparator, lodash_1["default"], lodash_1["default"], " and "))
                    .value();
            }
            remainingInterviewPanel = (0, exports.buildInterviewPanelString)({
                sortedVisibleEvents: sortedVisibleUpcomingEvents,
                timezone: timezone,
                withInterviewers: false
            });
            remainingInterviewPanelWithInterviewers = (0, exports.buildInterviewPanelString)({
                sortedVisibleEvents: sortedVisibleUpcomingEvents,
                timezone: timezone,
                withInterviewers: true
            });
            remainingInterviewPanelWithInterviewersFullNames =
                (0, exports.buildInterviewPanelString)({
                    sortedVisibleEvents: sortedVisibleUpcomingEvents,
                    timezone: timezone,
                    withInterviewers: true,
                    withInterviewerFullNames: true
                });
        }
    }
    var guideLink = "<a href=\"" + guideUrl + "\" target=\"_blank\" rel=\"noopener noreferrer\">Interview Guide</a>";
    var greenhouseJobLink = greenhouseJobUrl
        ? "<a href=\"" + greenhouseJobUrl + "\" target=\"_blank\" rel=\"noopener noreferrer\">Job Description</a>"
        : "";
    var clickHereLink = "<a href=\"" + guideUrl + "\" target=\"_blank\" rel=\"noopener noreferrer\">Click Here to Schedule Your Interview</a>";
    var allInterviewersFirstNames = (0, lodash_1["default"])(allInterviewers)
        .map("firstName")
        .sort()
        .thru(strings_1.joinWithFinalSeparator)
        .value();
    var allInterviewersFullNames = (0, lodash_1["default"])(allInterviewers)
        .map(function (_a) {
        var firstName = _a.firstName, lastName = _a.lastName;
        return (0, strings_1.joinNames)(firstName, lastName);
    })
        .sort()
        .thru(strings_1.joinWithFinalSeparator)
        .value();
    var firstInterviewer = (0, lodash_1["default"])(allInterviewers).sortBy("firstName").first();
    var firstInterviewerFullName = (0, strings_1.joinNames)(firstInterviewer === null || firstInterviewer === void 0 ? void 0 : firstInterviewer.firstName, firstInterviewer === null || firstInterviewer === void 0 ? void 0 : firstInterviewer.lastName);
    return {
        "all-interviewers-first-names": allInterviewersFirstNames,
        "all-interviewers-full-names": allInterviewersFullNames,
        "first-interviewer-first-name": (firstInterviewer === null || firstInterviewer === void 0 ? void 0 : firstInterviewer.firstName) || "",
        "first-interviewer-full-name": firstInterviewerFullName,
        "first-interviewer-title": (firstInterviewer === null || firstInterviewer === void 0 ? void 0 : firstInterviewer.title) || "",
        "company-name": data.companyName || "",
        "candidate-first-name": data.candidateFirstName || "",
        "candidate-full-name": data.candidateFullName || "",
        "scheduler-link": clickHereLink,
        "sender-name": data.senderName || "",
        "job-role-name": data.jobRoleName || "",
        "greenhouse-job-link": greenhouseJobLink,
        "next-interview-date": nextInterviewDay,
        "next-interview-time": nextInterviewTime,
        "guide-link": guideLink,
        "upcoming-interview-date": upcomingInterviewDate,
        "upcoming-interview-time": upcomingInterviewTime,
        "remaining-interview-datetime-range": remainingInterviewDatetimeRange,
        "remaining-interview-panel": remainingInterviewPanel,
        "remaining-interview-panel-with-interviewers": remainingInterviewPanelWithInterviewers,
        "remaining-interview-panel-with-interviewers-full-names": remainingInterviewPanelWithInterviewersFullNames,
        "recruiter-first-name": data.recruiterFirstName || "",
        "recruiter-full-name": data.recruiterFullName || "",
        "coordinator-first-name": data.coordinatorFirstName || "",
        "coordinator-full-name": data.coordinatorFullName || ""
    };
};
exports.getEmailReplacements = getEmailReplacements;
//# sourceMappingURL=placeholders.js.map